// Yapay Zekâ Yönetimi admin paneli için model yapılandırma listesi.

export interface AiModelConfig {
  id: string;
  name: string;
  role: string;
  description: string;
  modelId: string;
  active: boolean;
  fallback: string;
  timeoutMs: number;
  maxTokens: number;
  temperature: number;
  icon: string;
  provider: string;
}

export const aiModels: AiModelConfig[] = [
  {
    id: "tutor",
    name: "Ana Öğretmen",
    role: "AI öğretmen ve öğrenci koçu",
    description: "Doğal Türkçe sohbet, konu anlatımı, soru çözümü, quiz ve deneme analizi.",
    modelId: "deepseek-ai/deepseek-v4-flash-0731",
    active: true,
    fallback: "deepseek-ai/deepseek-v4-flash",
    timeoutMs: 30000,
    maxTokens: 1024,
    temperature: 0.7,
    icon: "ri-user-star-line",
    provider: "NVIDIA NIM",
  },
  {
    id: "vision",
    name: "Vision (Görsel)",
    role: "Fotoğraftan soru çözme",
    description: "Görseldeki soruyu analiz eder, metne çevirir ve çözüm için bilgi çıkarır.",
    modelId: "meta/muse-glimmer-30b",
    active: true,
    fallback: "—",
    timeoutMs: 45000,
    maxTokens: 1536,
    temperature: 0.4,
    icon: "ri-image-line",
    provider: "NVIDIA NIM",
  },
  {
    id: "embedding",
    name: "Embedding",
    role: "Öğrenci hafızası + RAG",
    description: "Metni vektöre çevirir; semantic search ve ders içerik aramada kullanılır.",
    modelId: "nvidia/nemotron-3-embed-1b",
    active: true,
    fallback: "—",
    timeoutMs: 15000,
    maxTokens: 512,
    temperature: 0,
    icon: "ri-braces-line",
    provider: "NVIDIA NIM",
  },
  {
    id: "safety",
    name: "Content Safety",
    role: "Çocuk güvenliği moderasyonu",
    description: "Giriş ve çıkışta içerik denetimi; cinsellik, şiddet ve zorbalığı tespit eder.",
    modelId: "nvidia/nemotron-3.5-content-safety",
    active: true,
    fallback: "Yerel desen taraması",
    timeoutMs: 10000,
    maxTokens: 16,
    temperature: 0,
    icon: "ri-shield-check-line",
    provider: "NVIDIA NIM",
  },
  {
    id: "translate",
    name: "Translate",
    role: "Türkçe/İngilizce ve yabancı dil",
    description: "YDS, YÖKDİL, kelime analizi ve paragraf çevirileri için kullanılır.",
    modelId: "nvidia/riva-translate-4b-instruct-v2",
    active: true,
    fallback: "Ana Öğretmen",
    timeoutMs: 30000,
    maxTokens: 1024,
    temperature: 0.3,
    icon: "ri-translate-2",
    provider: "NVIDIA NIM",
  },
  {
    id: "advanced",
    name: "Advanced Reasoning",
    role: "Zor sorular için opsiyonel",
    description: "İleri matematik, fizik ve çok adımlı reasoning görevlerinde devreye girer.",
    modelId: "nvidia/nemotron-3-ultra-550b-a55b",
    active: false,
    fallback: "Ana Öğretmen",
    timeoutMs: 60000,
    maxTokens: 2048,
    temperature: 0.5,
    icon: "ri-brain-line",
    provider: "NVIDIA NIM",
  },
];